/**
 * @desc color scale
 */
import { interpolateColor } from '@byted/light-render/lib/interpolate';
var ColorScale = /** @class */ (function () {
    function ColorScale() {
        this.type = 'color';
    }
    ColorScale.prototype.domain = function (domain) {
        this._domain = domain;
        return this;
    };
    ColorScale.prototype.colors = function (colors) {
        this._colors = colors;
        return this;
    };
    ColorScale.prototype.scale = function (propValue) {
        // @ts-ignore
        var value = parseFloat(propValue);
        var colors = this._colors;
        if (colors.length === 1) {
            return colors[0];
        }
        var step = 1 / (colors.length - 1);
        var _a = this._domain, min = _a[0], max = _a[1];
        var percent;
        if (min === max) {
            percent = 0.5;
        }
        else {
            percent = (value - min) / (max - min);
        }
        var startIndex;
        if (percent > 0 && percent < 1) {
            startIndex = Math.floor(percent / step);
        }
        else if (percent <= 0) {
            startIndex = 0;
        }
        else if (percent >= 1) {
            startIndex = colors.length - 2;
        }
        var endIndex = startIndex + 1;
        var startPercent = startIndex / (colors.length - 1);
        var rangePercent = (percent - startPercent) / step;
        return interpolateColor(colors[startIndex], colors[endIndex], rangePercent);
    };
    return ColorScale;
}());
export default ColorScale;
